export const SITE = {
    name: "ALBL Communications Private Limited",
    brand: "ALBL",
    phone: "9540088845",
    phoneHref: "tel:+919540088845",
    whatsapp: "https://wa.me/919540088845",
    whatsappPrefill:
        "https://wa.me/919540088845?text=" +
        encodeURIComponent("Hi ALBL — I'd like to discuss growth for my business."),
    email: "tripathiaakash93@gmail.com",
    emailHref: "mailto:tripathiaakash93@gmail.com",
    primaryMarket: "Narmadapuram, Madhya Pradesh",
};

export const NAV_LINKS = [
    { label: "Home", to: "/", testId: "nav-link-home" },
    { label: "About", to: "/about", testId: "nav-link-about" },
    { label: "Services", to: "/services", testId: "nav-link-services" },
    { label: "Why ALBL", to: "/why-albl", testId: "nav-link-why-albl" },
    { label: "Markets", to: "/markets", testId: "nav-link-markets" },
    { label: "Insights", to: "/insights", testId: "nav-link-insights" },
    { label: "Contact", to: "/contact", testId: "nav-link-contact" },
];

export const SERVICES = [
    {
        num: "01",
        title: "Brand Strategy",
        slug: "brand-strategy",
        short: "Positioning, communication, campaign thinking and brand-building designed around the business objective.",
        details: [
            "Brand positioning and value proposition built around your market",
            "Communication strategy — what to say, to whom, and why it wins",
            "Campaign thinking that connects brand to business objectives",
            "Brand identity direction and messaging frameworks",
        ],
        outcome:
            "A business that is chosen on purpose — not compared on price.",
    },
    {
        num: "02",
        title: "Retail & Trade Marketing",
        slug: "retail-trade-marketing",
        short: "Retail visibility, dealer/distributor activation, merchandising and market execution.",
        details: [
            "Retail visibility and in-store presence planning",
            "Dealer and distributor activation programmes",
            "Merchandising and point-of-sale communication",
            "Market execution across Narmadapuram, Itarsi and surrounding territories",
        ],
        outcome:
            "Your brand visible and moving where purchase decisions actually happen.",
    },
    {
        num: "03",
        title: "Digital Growth",
        slug: "digital-growth",
        short: "Social media, websites, landing pages, content, Google and Meta campaigns and digital strategy.",
        details: [
            "Digital strategy tied to business goals — not posting calendars",
            "Websites and landing pages built to convert visitors into enquiries",
            "Google and Meta advertising with local-market targeting",
            "Content and social media that builds authority, not just activity",
        ],
        outcome:
            "A digital presence that produces enquiries, not vanity metrics.",
    },
    {
        num: "04",
        title: "Customer Acquisition",
        slug: "customer-acquisition",
        short: "Hyperlocal campaigns, lead generation, digital advertising and customer acquisition strategies.",
        details: [
            "Hyperlocal campaigns built around your actual catchment area",
            "Lead generation systems with clear follow-up processes",
            "Local SEO and Google Business Profile optimisation",
            "Acquisition funnels measured from first touch to closed sale",
        ],
        outcome:
            "A predictable flow of new customers, not unpredictable bursts of luck.",
    },
    {
        num: "05",
        title: "Sales Growth",
        slug: "sales-growth",
        short: "Marketing strategies designed around enquiries, customers, conversions and business growth — not vanity metrics.",
        details: [
            "Sales-focused marketing plans tied to revenue objectives",
            "Enquiry-to-conversion journey diagnosis and improvement",
            "Offer, pricing-communication and promotion strategy",
            "Measurement frameworks that track what actually matters",
        ],
        outcome:
            "Marketing accountable to the same numbers your business is.",
    },
];

export const DONT_DO = [
    "No random posting just to \u201Cstay active\u201D.",
    "No copy-paste marketing packages.",
    "No vanity metrics without business impact.",
    "No one-size-fits-all strategies.",
    "No marketing plans that end up forgotten in an Excel file.",
];

export const WE_DO = [
    "Understand the business.",
    "Understand the market.",
    "Identify the growth opportunity.",
    "Build the strategy.",
    "Execute the campaign.",
    "Measure what matters.",
    "Improve continuously.",
];

export const BUSINESS_TYPES = [
    "Retailers",
    "Restaurants & cafés",
    "Hotels & hospitality",
    "Real estate businesses",
    "Education businesses",
    "Healthcare businesses",
    "Automobile dealers",
    "Consumer businesses",
    "Local manufacturers",
    "Distributors",
    "Service businesses",
    "Emerging local brands",
];

export const MARKETS = [
    { name: "Delhi", primary: false },
    { name: "Bhopal", primary: false },
    { name: "Indore", primary: false },
    { name: "Narmadapuram", primary: true },
    { name: "Itarsi", primary: true },
    { name: "Jabalpur", primary: false },
    { name: "Pipariya", primary: false },
    { name: "Sohagpur", primary: false },
    { name: "Seoni Malwa", primary: false },
    { name: "Bankhedi", primary: false },
    { name: "Babai", primary: false },
    { name: "Surrounding areas", primary: false },
];

export const PROCESS = [
    {
        num: "01",
        title: "Understand",
        text: "We understand your business, customer, market and current challenges.",
    },
    {
        num: "02",
        title: "Diagnose",
        text: "We identify where your marketing and sales journey is losing opportunity.",
    },
    {
        num: "03",
        title: "Build",
        text: "We create the strategy, campaigns, communication and execution plan.",
    },
    {
        num: "04",
        title: "Grow",
        text: "We measure, learn, optimise and scale what actually works.",
    },
];

export const DIAGNOSTIC_QUESTIONS = [
    "What are you selling?",
    "Who should buy it?",
    "Why should they choose you?",
    "Where are you losing customers?",
    "What is stopping your business from growing?",
];

export const FAQS = [
    {
        q: "What does ALBL Communications do?",
        a: "ALBL is a brand, marketing and sales growth partner helping businesses with brand strategy, retail and trade marketing, digital marketing, customer acquisition, local SEO, advertising and sales-focused marketing.",
    },
    {
        q: "Does ALBL work with businesses in Narmadapuram?",
        a: "Yes. Narmadapuram is one of ALBL's primary markets, along with Itarsi and surrounding areas.",
    },
    {
        q: "Does ALBL provide digital marketing?",
        a: "Yes. Digital marketing is one part of ALBL's broader approach, including social media, websites, landing pages, Google and Meta advertising, content and customer acquisition.",
    },
    {
        q: "Does ALBL work with small and local businesses?",
        a: "Yes. ALBL brings professional brand and sales-marketing thinking to ambitious local and growing businesses.",
    },
    {
        q: "Does ALBL work in Itarsi?",
        a: "Yes. ALBL serves businesses in Itarsi as well as Narmadapuram and nearby markets.",
    },
    {
        q: "Can ALBL help increase sales?",
        a: "ALBL develops marketing strategies around business objectives such as customer acquisition, enquiries, visibility, conversions and sales growth. Results depend on the business, market, offer and execution.",
    },
];

export const EXPERIENCE_BRANDS = ["LG", "Haier", "Bisleri"];

export const OFFICES = [
    { label: "Registered Office", value: "Alaknanda, New Delhi" },
    { label: "Branch Office", value: "Adjacent to DB Mall, MP Nagar, Bhopal" },
];
